const emailValidation = (email) => {
  const email_pattern = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/;
  return email_pattern.test(email)
}

export default emailValidation;